<template>
  <div class="index">
    <div class="top-tab flex flex-align-center flex-justify-end">
      <div style="padding: 5px 20px">
        <div v-if="parseInt(source) === 1">
          <!--总站-->
          <div v-if="user">
            <span>欢迎你，{{ name }}</span>
          </div>
          <div v-else>
            <span class="top-button" @click="toLogin">登录</span>
            <span class="top-button" @click="toRegister">注册</span>
          </div>
        </div>
      </div>
    </div>
    <!--<div class="index1">
      &lt;!&ndash;期数&ndash;&gt;
      <div class="index1-num">{{currentExam.title}}</div>
    </div>-->
    <div class="part1">
      <div class="part1-content"></div>
      <div class="part1-info">
        <div>第{{ currentExam.title }}期</div>
        <div class="part1-info-time">{{ timeChange(currentExam.start) }} - {{ timeChange(currentExam.end) }}</div>
      </div>
    </div>
    <div class="part2">
      <img src="../assets/2022/sanjiao-right.png" alt="">
      <span style="margin: 0 10px">中级会计职称考试</span>
      <img src="../assets/2022/sanjiao-left.png" alt="">
    </div>
    <div class="part3">
      <div v-for="(paper, index) in currentExam.paper" :key="index">
        <div v-if="parseInt(paper.course_id) === parseInt(course.kuaijishiwu)" class="part3-1">
          <unrunningbtn v-if="currentExam.running === -1" :currentExam="currentExam"></unrunningbtn>
          <div v-else-if="!currentExam.running" class="text-center">
            <div>
              <el-button disabled type="info" class="button">已结束</el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="danger" class="button orange" @click="watchScore(paper.id, 0)">
                查看排名
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="primary" class="button blue" @click="textParse(paper.id)">查看文字解析
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="primary" class="button blue" @click="videoNewParse(0)">
                查看视频解析
              </el-button>
            </div>
          </div>
          <div v-else class="text-center">
            <div>
              <el-button style="margin-top: 100px" v-if="!paper.done" type="success" class="button blue"
                @click="toExam(paper.id)">进入考试
              </el-button>
            </div>
            <div>
              <el-button v-if="!!paper.done" type="success" disabled class="button green">已完成
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="warning" class="button orange" @click="watchScore(paper.id, 0)">查看排名
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="primary" class="button blue" @click="textParse(paper.id)">查看文字解析
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="primary" class="button blue" @click="videoNewParse(0)">查看视频解析
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="parseInt(paper.course_id) === parseInt(course.jingjifa)" class="part3-2">
          <unrunningbtn v-if="currentExam.running === -1" :currentExam="currentExam"></unrunningbtn>
          <div v-else-if="!currentExam.running" class="text-center">
            <div>
              <el-button disabled type="info" class="button">已结束</el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="danger" class="button orange" @click="watchScore(paper.id, 0)">
                查看排名
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="primary" class="button blue" @click="textParse(paper.id)">查看文字解析
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="primary" class="button blue" @click="videoNewParse(1)">
                查看视频解析
              </el-button>
            </div>
          </div>
          <div v-else class="text-center">
            <div>
              <el-button style="margin-top: 100px" v-if="!paper.done" type="success" class="button blue"
                @click="toExam(paper.id)">进入考试
              </el-button>
            </div>
            <div>
              <el-button v-if="!!paper.done" type="success" disabled class="button green">已完成
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="warning" class="button orange" @click="watchScore(paper.id, 0)">查看排名
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="primary" class="button blue" @click="textParse(paper.id)">查看文字解析
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="primary" class="button blue" @click="videoNewParse(1)">查看视频解析
              </el-button>
            </div>
          </div>
        </div>
        <div v-if="parseInt(paper.course_id) === parseInt(course.caiwuguanli)" class="part3-3">
          <unrunningbtn v-if="currentExam.running === -1" :currentExam="currentExam"></unrunningbtn>
          <div v-else-if="!currentExam.running" class="text-center">
            <div>
              <el-button disabled type="info" class="button">已结束</el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="danger" class="button orange" @click="watchScore(paper.id, 0)">
                查看排名
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="primary" class="button blue" @click="textParse(paper.id)">查看文字解析
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button type="primary" class="button blue" @click="videoNewParse(2)">
                查看视频解析
              </el-button>
            </div>
          </div>
          <div v-else class="text-center">
            <div>
              <el-button style="margin-top: 100px" v-if="!paper.done" type="success" class="button blue"
                @click="toExam(paper.id)">进入考试
              </el-button>
            </div>
            <div>
              <el-button v-if="!!paper.done" type="success" disabled class="button green">已完成
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="warning" class="button orange" @click="watchScore(paper.id, 0)">查看排名
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="primary" class="button blue" @click="textParse(paper.id)">查看文字解析
              </el-button>
            </div>
            <div class="margin-top-10">
              <el-button v-if="!!paper.done" type="primary" class="button blue" @click="videoNewParse(2)">查看视频解析
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part4">
      <div class="part4-btn text-center">
        <img src="../assets/2022/explain.png" alt="">
      </div>
      <div class="part4-content">
        <div>1、请注册会员后提前预约。</div>
        <div>2、在规定时间范围内，任意时间参加考试即可。</div>
        <div>3、考试结束，系统自动公布参加考试人员排名。</div>
        <div>4、考试后会安排专职老师对本次考试题目进行直播讲解。未能参加直播的人员可查看直播回放</div>
        <div>5、注册会员免费参加，真实考试环境，超多考试原题</div>
        <div>6、考试后安排老师直播讲解。</div>
      </div>
    </div>
    <div class="part5">
      <div class="part5-title">
        <img src="../assets/2022/sanjiao-right.png" alt="">
        <span style="margin: 0 10px">{{ nowYear() }}年度考试安排</span>
        <img src="../assets/2022/sanjiao-left.png" alt="">
      </div>
      <div class="part5-content">
        <div class="part5-content-title text-center">“万人模考”不定期举行，具体时间请关注公告</div>
        <div class="part5-cal" id="history" v-if="historyData.length > 0">
          <!--往期回顾-->
          <div class="part5-cal-card">
            <el-carousel :interval="4000" :autoplay="true" height="300px">
              <el-carousel-item v-for="(item, period) in historyData" :key="item.id">
                <div class="part5-card-item">
                  <div class="part5-card-item-num">{{ nowYear() }}年第{{ item.title }}期</div>
                  <div class="part5-card-item-time"><i class="el-icon-time"></i> 考试时间: {{ timeChange(item.start) }}
                    - {{ timeChange(item.end) }}
                  </div>
                  <div class="part5-card-item-line1">
                    <div v-for="(paper, index) in item.paper" :key="index" style="flex: 1;text-align: center">
                      <el-button v-if="parseInt(paper.course_id) === course.kuaijishiwu" type="danger"
                        class="jianbian-orange" style="width: 90%" @click="textParse(paper.id)">《会计实务》文字解析
                      </el-button>
                      <el-button v-if="parseInt(paper.course_id) === course.jingjifa" type="danger" class="jianbian-blue"
                        style="width: 90%" @click="textParse(paper.id)">《经济法》文字解析
                      </el-button>
                      <el-button v-if="parseInt(paper.course_id) === course.caiwuguanli" type="danger"
                        class="jianbian-orange" style="width: 90%" @click="textParse(paper.id)">《财务管理》文字解析
                      </el-button>
                    </div>
                  </div>
                  <div class="part5-card-item-line2">
                    <div v-for="(paper, index) in item.paper" :key="index" style="flex: 1;text-align: center">
                      <el-button v-if="parseInt(paper.course_id) === course.kuaijishiwu" type="danger"
                        class="jianbian-blue" style="width: 90%" @click="videoNewHistory(period, index)">《会计实务》视频解析
                      </el-button>
                      <el-button v-if="parseInt(paper.course_id) === course.jingjifa" type="danger"
                        class="jianbian-orange" style="width: 90%" @click="videoNewHistory(period, index)">《经济法》视频解析
                      </el-button>
                      <el-button v-if="parseInt(paper.course_id) === course.caiwuguanli" type="danger"
                        class="jianbian-blue" style="width: 90%" @click="videoNewHistory(period, index)">《财务管理》视频解析
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
    <div class="part6">
      <div class="part4-content">
        <div style="border-bottom: solid 1px #6B2A48;padding: 10px 0;margin-bottom: 20px">
          <span style="display: flex;align-items: center"><span class="lineBold"></span>答题说明</span>
        </div>
        <div>1、试卷仅可答题一次，退出或交卷后无法再次作答，请选择合适的时间进入。</div>
        <div>2、考试期间不能中断或暂停。</div>
        <div>3、交卷后公布个人成绩。</div>
        <div>4、活动中的试卷难度接近但不等于真实考试，改成绩仅供参考。</div>
        <div style="border-bottom: solid 1px #6B2A48;padding: 10px 0;margin-bottom: 20px;margin-top: 30px">
          <span style="display: flex;align-items: center"><span class="lineBold"></span>得分说明</span>
        </div>
        <div>1、单项选择题：只有一个符合题意的正确答案。多选、错选、不选均不得分。</div>
        <div>
          2、多项选择题：有两个或者两个以上符合题意的正确答案。（至少选择两个答案，全部选对得满分，少选得相应分数，多选、多选、不选均不得分）。
        </div>
        <div>3、判断题：每小题答题正确得1分，错答、不答均不得分，也不扣分。</div>
        <div>4、不定项选择题：每小题有一个或者一个以上符合题意的答案，全部选对得满分。</div>
      </div>
    </div>
    <div class="part7">
      <img src="../assets/2022/part7.jpg" alt="">
    </div>
    <div class="part8">
      <img class="flex-1" src="../assets/2022/part8-1.png" alt="">
      <img style="width: 1280px" src="../assets/2022/part8-zhong.jpg" alt="">
      <img class="flex-1" src="../assets/2022/part8-2.png" alt="">
    </div>
    <div class="part9">
      <img src="../assets/2022/part9-zhong.jpg" alt="">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import unrunningbtn from './unrunningbtn'
import introvideo from './introvideo'

export default {
  name: 'index',
  components: {
    unrunningbtn,
    introvideo
  },
  data() {
    return {
      currentExam: {
        title: '',
        paper: [{ id: '0', done: 0 }, { id: '0', done: 0 }, { id: '0', done: 0 }],
        start: '',
        end: '',
        rules: '',
        introvideo: []
      },
      nowTime: '',
      historyData: [],
      historyRoom: ''
    }
  },
  computed: {
    ...mapState(['subject', 'course']),
    user() {
      return window.userInfo.key
    },
    source() {
      return window.userInfo.source
    },
    name() {
      return window.userInfo.name
    }
  },
  created() {
    this.initData()
  },
  methods: {
    // 跳转登录
    toLogin() {
      location.href = window.host + 'login?fromurl=' + window.host + 'mkindex/zhongjikuaiji'
    },
    toRegister() {
      location.href = window.host + 'register?fromurl=' + window.host + encodeURI('mkindex/zhongjikuaiji')
    },
    initData() {
      this.getCurrentExam()
    },
    getCurrentExam() {
      // 本期模考
      window.axios.get(`api/mokao/index/${window.mokaoType}`).then(res => {
        if (res.data.status) {
          this.currentExam = res.data.resultData
          // console.log(this.currentExam)
          // 处理富文本的不解析转义字符
          this.currentExam.rules = this.currentExam.rules.replace(this.currentExam.rules ? /&(?!#?\w+;)/g : /&/g, '&amp;')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '\'')
            .replace(/&#39;/g, '\'')
          // 考试状态的判断
          // 当前时间
          this.nowTime = Math.round(new Date().getTime() / 1000)
        }
      })
      //  取往期回顾
      this.getHistory(null)
    },
    nowYear() {
      let date = new Date()
      return date.getFullYear()
    },
    timeChange(timestamp) {
      // 根据时间戳生成的时间对象
      let date = new Date(timestamp * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = this.change(date.getDate()) + ' '
      let h = this.change(date.getHours()) + ':'
      let m = this.change(date.getMinutes())
      // let m = this.change(date.getMinutes()) + ':'
      // let s = this.change(date.getSeconds())
      // return Y + M + D + h + m + s
      return Y + M + D + h + m
    },
    change(t) {
      if (t < 10) {
        return '0' + t
      } else {
        return t
      }
    },
    getHistory(param) {
      if (param === null) {
        param = this.pagination
      }
      window.axios.get(`api/mokao/history/${window.mokaoType}`).then(res => {
        if (res.data.status === 1) {
          // console.log(res.data.resultData)
          // this.historyData = res.data.resultData.list
          let data = res.data.resultData.list
          let result = []
          data.forEach(v => {
            if (parseInt(v.start) > 1640966400) {
              result.push(v)
            }
          })
          this.historyData = result
          this.historyRoom = res.data.resultData.liveroom
          // console.log(this.historyData)
        } else {
          this.$message.error('获取失败')
        }
      })
    },
    toExam(id) { // zuoti
      // 跳转做题 首先判断有没有登录
      if (this.user !== '') {
        let routeData = this.$router.resolve(`/exam/${id}`)
        window.open(routeData.href, '_blank')
      } else {
        this.$message.warning('请先登录')
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      }
    },
    textParse(id) { // wenzijiexi
      if (this.user !== '') {
        let routeData = this.$router.resolve(`/ztparse/${id}`)
        window.open(routeData.href, '_blank')
      } else {
        this.$message.warning('请先登录')
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      }
    },
    videoParse(liveUrl) { // shipinjiexi
      if (this.user !== '') {
        let tmpArr = liveUrl.split(',')
        if (tmpArr.length > 1) {
          switch (parseInt(window.userInfo.source)) {
            case 1: // wenyunjy
              window.open(tmpArr[0], '_blank')
              break
            case 2: // wdexam
              window.open(tmpArr[1], '_blank')
              break
            default:
              window.open(tmpArr[0], '_blank')
              break
          }
        } else {
          // 只有一个
          window.open(liveUrl, '_blank')
        }
      } else {
        this.$message.warning('请先登录')
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      }
    },

    videoNewParse(index) { // shipinzhibo
      if (this.user !== '') {
        if (this.currentExam.urls[index] !== '') {
          window.open(this.currentExam.urls[index], '_blank')
        } else {
          this.$message.warning('回放地址生成中')
        }
      } else {
        this.$message.warning('请先登录')
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      }
    },
    watchScore(id, index) { // chakanpaiming
      if (this.user !== '') {
        let routeData = this.$router.resolve(`/score/${id}/${index}`)
        window.open(routeData.href, '_blank')
      } else {
        this.$message.warning('请先登录')
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      }
    },

    videoNewHistory(period, index) {
      console.log(this.historyData)
      window.open(this.historyData[period]['urls'][index], '_blank')
    },

    videoHistory() { // lishijiludeshipingjiexi
      if (this.user !== '') {
        let tmpArr = this.historyRoom.split(',')
        if (tmpArr.length > 1) {
          switch (parseInt(window.userInfo.source)) {
            case 1: // wenyunjy
              window.open(tmpArr[0], '_blank')
              break
            case 2: // wdexam
              window.open(tmpArr[1], '_blank')
              break
            default:
              window.open(tmpArr[0], '_blank')
              break
          }
        } else {
          // 只有一个
          window.open(this.historyRoom, '_blank')
        }
      } else {
        this.$message.warning('请先登录')
        setTimeout(() => {
          this.toLogin()
        }, 1000)
      }
    }
  }
}
</script>
<style>
.nav-button-width {
  width: 114px;
  font-size: 18px;
}

.card-item-line1 .el-button {
  /*width: 154px;*/
}

.card-item-line2 .pule {
  width: 154px !important;
  background-color: #4D62F4 !important;
  border-color: #4D62F4 !important;
}

.card-item-line2 .pule:hover {
  opacity: 0.9;
}

.index5 .el-button+.el-button {
  margin-left: 0 !important;
}

.index5-div .green {
  background-color: #0CDE95 !important;
  border-color: #0CDE95 !important;
}

.index5-div .green:hover {
  opacity: 0.9;
}

.index5-div .purple {
  background-color: #BC69F6 !important;
  border-color: #BC69F6 !important;
}

.index5-div .purple:hover {
  opacity: 0.9;
}

.index5-div .blue {
  background-color: #1881FE !important;
  border-color: #1881FE !important;
}

.index5-div .blue:hover {
  opacity: 0.9;
}

.blue {
  background-color: #3C84EA !important;
  border-color: #3C84EA !important;
}

.orange {
  /*  FD8A6B*/
  background-color: #FD8A6B !important;
  border-color: #FD8A6B !important;
}

.jianbian-blue {
  background: linear-gradient(to right, #3D86EB, #0A44BF) !important;
  /*background-color: #3C84EA !important;*/
  border-color: #0A44BF !important;
  font-size: 16px;
}

.jianbian-orange {
  background: linear-gradient(to right, #FE896B, #ED3831) !important;
  /*background-color: #3C84EA !important;*/
  border-color: #ED3831 !important;
  font-size: 16px;
}

.index5-div .darkGreen {
  background-color: #1DD5C7 !important;
  border-color: #1DD5C7 !important;
}

.index5-div .darkGreen:hover {
  opacity: 0.9;
}
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  width: 100%;
  height: auto;
  background-color: #02013D;
  position: relative;
  z-index: 1;
  min-width: 1280px;
}

.top-tab {
  position: absolute;
  top: 0;
  width: 100%;
  height: auto;
  padding: 5px 0;
  /*height: 30px;*/
  background-color: #333;
  z-index: 3;
  box-sizing: border-box;
  color: #ffffff;
}

.top-button {
  color: #FFF;
  border: 1px solid #bcbcbc;
  padding: 4px 10px;
  border-radius: 1px;
  margin-right: 5px;
  font-size: 12px;
  cursor: pointer;
}

.part1 {
  width: 100%;
  height: 600px;
  background: url("../assets/2022/part1.jpg") bottom;
  z-index: 2;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.part1-content {
  width: 700px;
  height: 320px;
  background: url("../assets/2022/title.png") no-repeat center;
  background-size: 600px 350px;
}

.part1-info {
  position: absolute;
  bottom: 20px;
  color: #FFFFFF;
  text-align: center;
  font-size: 30px;
  font-family: 微软雅黑;
}

.part1-info-time {
  margin-top: 10px;
  font-size: 20px;
  color: #ffffff;
  padding: 10px;
}

.part2 {
  font-size: 35px;
  letter-spacing: 1px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  padding-bottom: 10px;
  background: url("../assets/2022/jianbian.jpg") no-repeat center;
  background-size: 100%;
}

.part3 {
  display: flex;
  justify-content: center;
  justify-items: center;
  padding: 50px 0;
  background: url("../assets/2022/jianbian.jpg") no-repeat center;
  background-size: 100%;
}

.part3-1 {
  width: 400px;
  height: 400px;
  background: url("../assets/2022/zhongjishiwu.png");
  margin-right: 20px;
  position: relative;
  box-sizing: border-box;
  padding-top: 150px;
}

.part3-2 {
  width: 400px;
  height: 400px;
  background: url("../assets/2022/jingjifa.png");
  margin-right: 20px;
  position: relative;
  box-sizing: border-box;
  padding-top: 150px;
}

.part3-3 {
  width: 400px;
  height: 400px;
  background: url("../assets/2022/caiwuguanli.png");
  position: relative;
  box-sizing: border-box;
  padding-top: 150px;
}

.part4 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  background: url("../assets/2022/jianbian.jpg") no-repeat center;
  background-size: 100%;
}

.part4-btn {
  width: 800px;
  border-bottom: solid 1px #9DA0C2;
}

.part4-content {
  width: 800px;
  color: #FEFEFE;
  font-size: 16px;
  line-height: 30px;
  margin-top: 10px;
}

.part5 {
  font-size: 35px;
  letter-spacing: 1px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 80px;
  padding-bottom: 10px;
  background: url("../assets/2022/jianbian.jpg") no-repeat center;
  background-size: 100%;
}

.part5-title {
  display: flex;
  align-items: center;
}

.part5-content {
  width: 800px;
}

.part5-content-title {
  margin: 20px 0;
  font-size: 16px;
  color: #929AEB;
}

.part5-cal {
  height: 400px;
  width: 800px;
  margin: 40px auto 0;
  /*background: #3c2166 url('../assets/index6.png') no-repeat center;*/
  position: relative;
  z-index: 1;
}

.part5-cal-card {
  position: absolute;
  width: 800px;
  height: 400px;
  /*margin-top: 188px;*/
  z-index: 2;
  padding: 10px;
  box-sizing: border-box;
}

.part5-card-item {
  /*width: 640px;*/
  height: 100%;
  /*background: url("../assets/index7.png") no-repeat center;*/
  background-color: #ffffff;
  color: #333333;
  border-radius: 10px;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  padding: 30px;
}

.part5-card-item-num {
  width: auto;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  color: #333333;
  font-family: 仿宋;
  z-index: 2;
}

.part5-card-item-time {
  text-align: center;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  color: #666666;
  z-index: 2;
  border-bottom: solid 1px #eeeeee;
  width: 92%;
  margin: 0 auto;
}

.part5-card-item-line1 {
  height: 50px;
  line-height: 50px;
  width: 100%;
  display: flex;
  margin-top: 20px;
}

.part5-card-item-line2 {
  margin-top: 15px;
  height: 50px;
  line-height: 50px;
  width: 100%;
  display: flex;
}

.part6 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  background: url("../assets/2022/jianbian.jpg") no-repeat center;
  background-size: 100%;
  color: #FEFEFE;
}

.part7 {
  width: 100%;
  /*height: 975px;*/
  text-align: center;
  background-color: #06054B;
}

.part8 {
  width: 100%;
  text-align: center;
  /*background: url("../assets/2022/part8-1.png") repeat;*/
  display: flex;
  height: 721px;
  overflow-x: hidden;
}

.part9 {
  width: 100%;
  text-align: center;
  background: url("../assets/2022/part9-1.png") repeat;
}

.index1 {
  width: 1280px;
  height: 230px;
  margin: 0 auto;
  background: url('../assets/index1.png') no-repeat center;
  z-index: 2;
  position: relative;
}

.index1-num {
  position: absolute;
  width: 100px;
  height: 78px;
  line-height: 78px;
  left: 590px;
  top: 123px;
  color: #BED4F6;
  /*border: solid 1px white;*/
  font-size: 80px;
  font-weight: bold;
  text-shadow: #91ffff 0 0 10px;
  z-index: 3;
  text-align: center;
}

.index2 {
  width: 1280px;
  height: 216px;
  margin: 0 auto;
  background: url('../assets/index2.png') no-repeat center;
  position: relative;
  z-index: 1;
}

.index3 {
  height: 190px;
  width: 1280px;
  margin: 0 auto;
  background: url('../assets/index3.png') no-repeat center;
  position: relative;
  z-index: 1;
}

.index3-time {
  position: absolute;
  width: 275px;
  height: 43px;
  line-height: 43px;
  left: 505px;
  top: 16px;
  color: #ffffff;
  /*border: solid 1px white;*/
  text-align: center;
  z-index: 2;
}

.index4 {
  height: 700px;
  width: 1280px;
  margin: 0 auto;
  background: url('../assets/index4.png') no-repeat center;
  position: relative;
  z-index: 1;
}

.index4-info {
  /*
  1105px;
  height: 330px;
  line-height: 43px;
  left: 70px;
  top: 210px;*/
  position: absolute;
  width: 1100px;
  height: 330px;
  line-height: 35px;
  left: 80px;
  top: 180px;
  color: #bdafe8;
  letter-spacing: 1px;
  /*text-indent: 2em;*/
  /*border: solid 1px white;*/
  z-index: 2;
}

.index5 {
  height: 657px;
  width: 1280px;
  margin: 0 auto;
  /*background:#3c2166 url('../assets/index5.png') no-repeat center;*/
  z-index: 1;
  position: relative;
}

.index5-header {
  width: 1280px;
  height: 135px;
  margin: 0 auto;
  z-index: 1;
  position: relative;
  background: #3c2166 url('../assets/index5_header.png') no-repeat center;
}

.index5-bottom {
  width: 1280px;
  height: 519px;
  margin: 0 auto;
  z-index: 1;
  position: relative;
  background-color: #3c2166;
  display: flex;
}

.index5-bottom1 {
  width: 400px;
  height: 519px;
  margin-right: 40px;
  background: #3c2166 url('../assets/index5_bottom1.png') no-repeat center;
  z-index: 1;
  position: relative;
}

.index5-bottom2 {
  width: 400px;
  height: 519px;
  margin-right: 40px;
  background: #3c2166 url('../assets/index5_bottom2.png') no-repeat center;
  z-index: 1;
  position: relative;
}

.index5-bottom3 {
  width: 400px;
  height: 519px;
  background: #3c2166 url('../assets/index5_bottom3.png') no-repeat center;
  z-index: 1;
  position: relative;
}

.index5-div {
  position: relative;
  float: left;
  width: 400px;
  height: 260px;
  /*border: solid 1px white;*/
  margin: 235px 0 0 0;
}

.index5-div:nth-child(2) {
  margin-left: 40px;
  margin-right: 40px;
}

.index6 {
  height: 500px;
  width: 1280px;
  margin: 0 auto;
  background: #3c2166 url('../assets/index6.png') no-repeat center;
  position: relative;
  z-index: 1;
}

.index6-card {
  position: absolute;
  width: 1280px;
  height: 280px;
  margin-top: 188px;
  z-index: 2;
  padding: 10px;
  box-sizing: border-box;
}

.card-item {
  /*width: 640px;*/
  height: 250px;
  background: url("../assets/index7.png") no-repeat center;
  position: relative;
  z-index: 2;
}

.card-item-num {
  position: absolute;
  width: auto;
  height: 30px;
  line-height: 30px;
  top: 34px;
  left: 48px;
  text-align: center;
  font-size: 28px;
  font-weight: bold;
  color: #4371fa;
  z-index: 2;
}

.card-item-time {
  position: absolute;
  width: 300px;
  height: 25px;
  line-height: 25px;
  top: 75px;
  left: 25px;
  font-size: 15px;
  color: #999;
  font-weight: bold;
  z-index: 2;
}

.card-item-line1 {
  position: absolute;
  top: 110px;
  left: 0;
  height: 50px;
  line-height: 50px;
  padding-left: 25px;
  display: flex;
}

.card-item-line2 {
  position: absolute;
  top: 165px;
  height: 50px;
  line-height: 50px;
  padding-left: 25px;
  display: flex;
}

.aside-nav {
  position: absolute;
  top: 150px;
  left: 30px;
  z-index: 3;
}

.index7 {
  height: auto;
  width: 1280px;
  margin: 0 auto;
  padding: 0 0 20px 0;
  /*background:#3c2166 url('../assets/index5.png') no-repeat center;*/
  z-index: 1;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/zhongji.vue